import React from "react";

export default function BlogLandingHeader() {
  return (
    <div className="section-header">
      <span className="pill">Writing</span>
      <h1 className="section-title">Notes on engineering, architecture, and delivery.</h1>
      <p className="section-copy">
        Practical write-ups from the systems side of software: implementation details, trade-offs,
        and lessons worth keeping.
      </p>
    </div>
  );
}
